<template>
  <b-card class="project-performance" v-if="hasRight(user, 'dashboard', 'view')" no-body>
    <b-card-body>
      <b-table :items="projectPerformanceData" :fields="fields" per-page="5" small striped responsive></b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BTable } from 'bootstrap-vue';
import { hasRight } from '@/utils/auth';
import { dashboardGet } from './dashboardApi';

export default {
  name: 'ProjectPerformance',
  components: {
    BCard,
    BCardBody,
    BTable,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    dashboardData: { type: Object, default: null },
    useAggregate: { type: Boolean, default: false },
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },
  data() {
    return {
      fields: [
        { key: 'project_name', label: 'Project' },
        { key: 'total_closures', label: 'Total Closures' },
        { key: 'total_revenue', label: 'Total Revenue' },
      ],
      projectPerformanceData: [],
    };
  },
  watch: {
    dashboardData: {
      deep: true,
      handler(val) {
        if (val && val.project_performance != null && hasRight(this.user, 'dashboard', 'view')) {
          this.projectPerformanceData = Array.isArray(val.project_performance) ? [...val.project_performance] : [];
        }
      },
    },
    filters: {
      deep: true,
      immediate: true,
      handler() {
        if (!hasRight(this.user, 'dashboard', 'view')) return;
        if (this.useAggregate) {
          if (this.dashboardData && this.dashboardData.project_performance != null) this.projectPerformanceData = Array.isArray(this.dashboardData.project_performance) ? [...this.dashboardData.project_performance] : [];
          return;
        }
        if (this.dashboardData && this.dashboardData.project_performance != null) { this.projectPerformanceData = Array.isArray(this.dashboardData.project_performance) ? [...this.dashboardData.project_performance] : []; return; }
        this.fetchProjectPerformanceData();
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (hasRight(newVal, 'dashboard', 'view')) {
          if (this.useAggregate) {
            if (this.dashboardData && this.dashboardData.project_performance != null) this.projectPerformanceData = Array.isArray(this.dashboardData.project_performance) ? [...this.dashboardData.project_performance] : [];
            return;
          }
          this.fetchProjectPerformanceData();
        } else {
          this.projectPerformanceData = [];
        }
      },
    },
  },
  methods: {
    hasRight, // Make the helper available in the template
    async fetchProjectPerformanceData() {
      if (!hasRight(this.user, 'dashboard', 'view')) return;
      if (this.useAggregate || (this.dashboardData && this.dashboardData.project_performance != null)) {
        if (this.dashboardData && this.dashboardData.project_performance != null) this.projectPerformanceData = Array.isArray(this.dashboardData.project_performance) ? [...this.dashboardData.project_performance] : [];
        return;
      }
      try {
        const response = await dashboardGet(this.baseApi, this.accessToken, '/dashboard/crm/project-performance', this.filters);
        const raw = response.data && response.data.data;
        this.projectPerformanceData = Array.isArray(raw) ? [...raw] : [];
      } catch (error) {
        console.error('Error fetching project performance data:', error);
        // Handle error
      }
    },
  },
};
</script>

<style scoped>
.project-performance {
  margin-top: 20px;
}
</style>